import {ChangeDetectorRef, Component, Input, Optional, Self} from '@angular/core';
import {ControlValueAccessor, NgControl, NgModel} from '@angular/forms';

@Component({
  selector: 'ds-switch',
  templateUrl: './switch.component.html',
  styleUrls: ['./switch.component.scss']
})
export class SwitchComponent implements ControlValueAccessor {
  @Input() label: string;
  @Input() on = 'On';
  @Input() off = 'Off';
  @Input() isDisabled = false;
  isChecked: boolean;
  onChange;
  onTouched;

  constructor(
    @Optional() @Self() public ngControl: NgControl,
    @Optional() @Self() public ngModel: NgModel,
    private cdRef: ChangeDetectorRef
  ) {
    if (ngControl) {
      ngControl.valueAccessor = this;
    }
    if (ngModel) {
      ngModel.valueAccessor = this;
    }
  }

  set value(isChecked) {
    this.isChecked = isChecked;
    if (this.onChange) {
      this.onChange(this.isChecked);
    }
  }

  get value(): boolean {
    return this.isChecked;
  }

  writeValue(isChecked: boolean): void {
    this.value = isChecked;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

}
